export default "__VITE_ASSET__rBeEPCN8__"